export function getBusinessRegistrationLabelTranslationKey(
  countryCode: string | null | undefined
): string {
  const code = (countryCode || '').toUpperCase()
  const supported = new Set(['CN', 'IN', 'GB', 'US', 'KR', 'TR', 'UA'])
  if (supported.has(code)) {
    return `organizationDetails.businessIdLabel.${code}`
  }
  return 'organizationDetails.businessIdLabel.default'
}
